import i18n from "@/assets/lang";
/**
 * 描述 校验必传
 * @date 2022-03-01
 * @param {any} message
 * @returns {any}
 */
const rulesRequired = ({ message, trigger = ["change", "blur"] }) => ({ required: true, message, trigger });
/**
 * 描述 密码校验
 * @date 2022-03-01
 * @param {any} rule
 * @param {any} value
 * @param {any} callback
 * @returns {any}
 */
const validatePassword = (rule, value, callback) => {
  const reg = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(i18n.t("public.characterLimit")));
  }
};

const rulesPassword = ({ rule, value, callback, start = 8, end = 16 }) => {
  const reg = new RegExp(`((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{${start},${end}}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{{${start},${end}}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{${start},${end}}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{${start},${end}}$))`, "gim");
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(i18n.t("public.characterLimit")));
  }
};

/**
 * 描述 校验2个字段值是否一样
 * @date 2022-03-01
 * @param {any} checkVal: 要对比的值
 * @param {any} errorMsg: 自定义错误描述
 * @returns {any}
 */
const rulesCheckTwoField = ({ rule, value, callback, checkVal, errorMsg = ["", ""] }) => {
  if (value === "") {
    callback(new Error(errorMsg[0] || "请再次输入密码"));
  } else if (value !== checkVal) {
    callback(new Error(errorMsg[0] || "两次输入密码不一致!"));
  } else {
    callback();
  }
};

export {
  rulesRequired,
  validatePassword,
  rulesPassword,
  rulesCheckTwoField
};
